import React from 'react';
import PropTypes from 'prop-types';
import GreenSelectButton from './greenSelectButton';
import { Box, Typography } from '@mui/material';

const GreenRow = ({ venue, green, onRinkToggle }) => {
  return (
    <Box display={'flex'} alignItems={'center'} mb={1} p={1}>
      <Typography variant="span" color="textPrimary" style={{ marginRight: '8px' }}>
        {green.name}
      </Typography>

      <Box display={'flex'} flexDirection={'row'} flexWrap={'nowrap'} gap={1}>
        {green.rinks.map((rink) => (
          <GreenSelectButton
            key={`${green.name}${rink.rink}`}
            venue={venue}
            green={green}
            rink={rink.rink}
            active={rink.active}
            onToggle={(rinkNumber) => onRinkToggle(green.name, rinkNumber)}
          />
        ))}
      </Box>
    </Box>
  );
};

GreenRow.propTypes = {
  venue: PropTypes.object.isRequired,
  green: PropTypes.shape({
    name: PropTypes.string.isRequired,
    rinks: PropTypes.array.isRequired
  }).isRequired
};

export default GreenRow;
